export const getFilter = ({ filter }) => filter;